import type { TCriarAtendimentoResponse } from '@/features/atendimento/interfaces'
import { HttpService } from '@/shared/lib'

export class CriarAtendimentoService extends HttpService {
  async execute(clienteId: string): Promise<TCriarAtendimentoResponse> {
    const response = await this.http.post<TCriarAtendimentoResponse>('api/v2/Atendimento', { clienteId })
    return response.data
  }
}
